import React from 'react';
import cx from 'classnames';

import styles from './styles.css';

export type Props = {
  children?: any;
  title?: string | React.Component;
  description?: string | React.Component;
  className?: string;
};

export const Box = ({ children, className, title, description }: Props) => (
  <div className={cx(styles.root, className)}>
    {title && <h5 className={styles.title}>{title}</h5>}
    {description && <p className={styles.description}>{description}</p>}
    {children && <div className={styles.body}>{children}</div>}
  </div>
);
